export default __webpack_public_path__ + "static/Asset9@2x-febe856285137a956178e9f278fc3d0e.png";